import React from 'react';
import { motion } from 'framer-motion';
const buckets = [{
  id: '01',
  title: 'DELIVERY THROUGHPUT',
  desc: 'DORA metrics (Deploy Frequency, Lead Time, MTTR, CFR) to measure how fast and safely code ships.'
}, {
  id: '02',
  title: 'DEVELOPER EXPERIENCE',
  desc: 'SPACE and DevEx frameworks combining qualitative surveys with system data to measure friction.'
}, {
  id: '03',
  title: 'BUSINESS ALIGNMENT',
  desc: 'R&D allocation and capitalization tracking to show executives where engineering time is spent.'
}, {
  id: '04',
  title: 'WORKFLOW AUTOMATION',
  desc: 'PR analytics and automated routing to unblock reviews and reduce cycle time bottlenecks.'
}];
export function CategoryExplainer() {
  return <section id="overview" className="py-24 bg-base relative" data-id="element-40">
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8" data-id="element-41">
        <div className="mb-16 font-mono" data-id="element-42">
          <div className="text-lime text-xs tracking-widest mb-4" data-id="element-43">
            §01 / OVERVIEW
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink uppercase tracking-tight mb-6" data-id="element-44">
            Core Vectors
          </h2>
          <p className="text-ink/60 text-sm max-w-2xl leading-relaxed hairline-l pl-6 border-ink/20" data-id="element-45">
            The category has evolved from simple git analytics into
            comprehensive platforms that blend system data with developer
            sentiment to solve four distinct problems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 hairline-t hairline-l" data-id="element-46">
          {buckets.map((bucket, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          ease: 'easeOut'
        }} className="hairline-r hairline-b p-8 relative group hover:bg-ink/5 transition-colors" data-id="element-47">
              <div className="absolute top-4 right-4 font-mono text-xs text-ink/30 group-hover:text-lime transition-colors" data-id="element-48">
                [{bucket.id}]
              </div>

              {/* Crosshairs */}
              <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-ink/50 -translate-x-px -translate-y-px" data-id="element-49" />
              <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-ink/50 translate-x-px translate-y-px" data-id="element-50" />

              <h3 className="font-mono text-sm font-bold text-ink mb-4 mt-8 tracking-wider" data-id="element-51">
                {bucket.title}
              </h3>
              <p className="font-mono text-xs text-ink/50 leading-relaxed" data-id="element-52">
                {bucket.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}